import {
  Required,
  DataValidator,
  transformKeys,
  IsString,
  IsNumber,
} from "@/utils/type-vaildator";
import api from "./api";

interface MiutaPriceResponse {
  item_code: string;
  item_name: string;
  trial_period_price: number;
  price: number;
  discount_price: number;
}

export class MiutaPriceData {
  @Required("item code cannot be empty")
  @IsString("item code must be a string")
  itemCode: string;

  @Required("item name cannot be empty")
  @IsString("item name must be a string")
  itemName: string;

  @Required("price cannot be empty")
  @IsNumber("price must be a number")
  price: number;
}

const transformAndValidateData = (
  response: MiutaPriceResponse
): MiutaPriceData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, MiutaPriceData);
  } catch (error) {
    console.error("Miuta price data validation failed:", error.message);
    throw error;
  }
};

/** 获取 Miuta 价格 */
export const miutaPrice = async (): Promise<MiutaPriceData[]> => {
  const res = await api.get<MiutaPriceResponse[]>('/miuta/prices');
  const data = res.data.map(transformAndValidateData);
  return data;
}